import React from "react";

function Legal() {
  return (
    <>
      <div className="mt-30">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16">
          <h1 className="mb-4 mt-5 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-4xl lg:text-4xl dark:text-white">
            Privacy Policy
          </h1>

          <p>
            CurioCode Solution website is owned by CurioCode Solution, which is
            a data controller of your personal data. We have adopted this
            Privacy Policy, which determines how we are processing the
            information collected by CurioCode Solution, which also provides the
            reasons why we must collect certain personal data about you.
            Therefore, you must read this Privacy Policy before using CurioCode
            Solution website. We take care of your personal data and undertake
            to guarantee its confidentiality and security.
          </p>
          <h2 className="mb-4 mt-5 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">
            Personal information we collect:
          </h2>
          <p>
            When you visit the CurioCode Solution website, we automatically
            collect certain information about your device, including information
            about your web browser, IP address, time zone, and some of the
            installed cookies on your device. Additionally, as you browse the
            Site, we collect information about the individual web pages or
            products you view, what websites or search terms referred you to the
            Site, and how you interact with the Site. We refer to this
            automatically-collected information as “Device Information.”
            Moreover, we might collect the personal data you provide to us
            (including but not limited to Name, Surname, Address, payment
            information, etc.) during registration to be able to fulfill the
            agreement.
          </p>

          <h2 className="mb-4 mt-5 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">
            Why do we process your data?
          </h2>
          <p>
            Our top priority is customer data security, and, as such, we may
            process only minimal user data, only as much as it is absolutely
            necessary to maintain the website. Information collected
            automatically is used only to identify potential cases of abuse and
            establish statistical information regarding website usage. This
            statistical information is not otherwise aggregated in such a way
            that it would identify any particular user of the system. You can
            visit the website without telling us who you are or revealing any
            information, by which someone could identify you as a specific,
            identifiable individual. If, however, you wish to use some of the
            website’s features, or you wish to receive our newsletter or provide
            other details by filling a form, you may provide personal data to
            us, such as your email, first name, last name, city of residence,
            organization, telephone number. You can choose not to provide us
            with your personal data, but then you may not be able to take
            advantage of some of the website’s features. For example, you won’t
            be able to receive our Newsletter or contact us directly from the
            website. Users who are uncertain about what information is mandatory
            are welcome to contact us via curiocodesolution@gmail.com.
          </p>
          <h2 className="mb-4 mt-5 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-2xl dark:text-white">
            Your rights:
          </h2>
          <ol class="list-decimal list-inside space-y-2">
            <li>The right to be informed. The right of access.</li>
            <li>The right to rectification.</li>
            <li>The right to erasure.</li>
            <li>The right to restrict processing.</li>
            <li>The right to data portability.</li>
            <li>The right to object.</li>
            <li class="mt-2">
              Rights in relation to automated decision-making and profiling. If
              you would like to exercise these rights, please contact us through
              the contact information below. Additionally, if you are a European
              resident, we note that we are processing your information in order
              to fulfill contracts we might have with you (for example, if you
              make an order through the Site), or otherwise to pursue our
              legitimate business interests listed above. Additionally, please
              note that your information might be transferred outside of Europe,
              including Canada and the United States.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
}

export default Legal;
